import { getData, postData } from './apiCall';
import jwt_decode from 'jwt-decode';
import { toApiError } from 'utils/moduleDisabled';

export const getRecognitionData = async ({ queryKey: [_key, authToken, messageId] }) => {
    const url = messageId ? `teams/task-module/recognition?messageId=${messageId}` : `teams/task-module/recognition`;
    try {
        const response = await getData(url, authToken);
        return response?.data;
    } catch (error) {
        throw toApiError(error);
    }
};

export const getBonusData = async ({ queryKey: [_key, authToken] }) => {
    try {
        const response = await getData(`teams/task-module/bonus`, authToken);
        return response?.data;
    } catch (error) {
        throw toApiError(error);
    }
};

export const enhanceMessage = async ({ reason, authToken }) => {
    const payload = {
        message: reason,
    };
    try {
        const path = 'ai/enhance-text';
        const { data } = await postData(path, payload, authToken);
        return data.message;
    } catch (error) {
        throw toApiError(error);
    }
};
export const getUsers = async (payload, authToken) => {
    try {
        const response = await postData('api/v2/dashboard/user/compact/list', payload, authToken);
        return response?.data?.result;
    } catch (error) {
        throw toApiError(error);
    }
};

export const getChannels = async (authToken) => {
    const decode = jwt_decode(authToken);
    try {
        const response = await getData(`api/v1/slack/${decode['team-id']}/channels`, authToken);
        return response?.data;
    } catch (error) {
        throw toApiError(error);
    }
};

export const getPulseData = async ({ queryKey: [_key, authToken, responseId] }) => {
    try {
        const response = await getData(`teams/task-module/pulse/startAnswer?responseId=${responseId}`, authToken);
        return response?.data;
    } catch (error) {
        throw toApiError(error);
    }
};

export const getGifList = async ({ queryKey: [_key, authToken, rewardType] }) => {
    try {
        const response = await getData(`recognition/gif-list?rewardType=${rewardType}`, authToken);
        return response?.data;
    } catch (error) {
        throw toApiError(error);
    }
};

export const getSuggestionBoxData = async ({ queryKey: [_key, authToken] }) => {
    try {
        const response = await getData(`teams/task-module/suggestion`, authToken);
        return response?.data;
    } catch (error) {
        throw toApiError(error);
    }
};

export const getRequestFeedbackData = async ({ queryKey: [_key, authToken] }) => {
    try {
        const response = await getData('teams/task-module/feedback/requestFeedback', authToken);
        return response?.data;
    } catch (error) {
        throw toApiError(error);
    }
};

export const getSendFeedbackData = async ({ queryKey: [_key, authToken] }) => {
    try {
        const response = await getData('teams/task-module/feedback/sendFeedback', authToken);
        return response?.data;
    } catch (error) {
        throw toApiError(error);
    }
};

export const getWorkspaceConfig = async ({ queryKey: [_key, authToken] }) => {
    try {
        const response = await getData('recognition/configure/workspace', authToken);
        return response?.data;
    } catch (error) {
        throw toApiError(error);
    }
};

export const getIntrosConfig = async ({ queryKey: [_key, authToken] }) => {
    try {
        const response = await getData('workspace/profile', authToken);
        return response?.data;
    } catch (error) {
        throw new Error(error?.response?.data?.message);
    }
};

// The profile gates every Teams tab, so cap the wait: a timeout rejects and callers fail open.
export const WORKSPACE_PROFILE_TIMEOUT_MS = 5000;

export const getWorkspaceProfile = async ({ queryKey: [_key, authToken] }) => {
    try {
        const response = await getData('workspace/profile', authToken, null, { timeout: WORKSPACE_PROFILE_TIMEOUT_MS });
        return response?.data;
    } catch (error) {
        throw toApiError(error);
    }
};
